import React, {useEffect, useState} from 'react';
import {CardContent, useToastProvider} from '@deere/fuel-react';
import {useStyles} from "../shared/styles/Ratings";
import Accordion from "@material-ui/core/Accordion";
import {RatingObjective} from "./RatingObjective";
import {RatingObjectiveDetails} from './RatingObjectiveDetails';
import {useAuthConfig} from "../shared/helper";
import {RatingCriteriaDetails} from "./RatingCriteriaDetails";
import {RatingCriteriaSummary} from "./RatingCriteriaSummary";

export const RatingCriteriaList = ({
                                       criteria,
                                       isActionsAllowed,
                                       suppliers,
                                       userInfo,
                                       isSupplierMimic,
                                       isSupplierAdmin,
                                       functionalAreaId,
                                       ratingPeriod,
                                       updateVisibilityState
                                   }) => {
    const classes = useStyles();
    const {enqueueToast} = useToastProvider();
    const authAxios = useAuthConfig();
    const [expanded, setExpanded] = useState('panel1');
    const [isAddCommentOpen, setIsAddCommentOpen] = useState(false);
    const [isEditCommentOpen, setIsEditCommentOpen] = useState(false);
    const [criteriaComments, setCriteriaComments] = useState([]);
    const [isOverrideScoreOpen, setIsOverrideScoreOpen] = useState(false);
    const [isEditOverrideScoreOpen, setIsEditOverrideScoreOpen] = useState(false);
    const [originalValue, setOriginalValue] = useState("");
    const [overrideValue, setOverrideValue] = useState("");
    const [isOverrideEdit, setIsOverrideEdit] = useState(false);
    const [isNotApplicableOpen, setIsNotApplicableOpen] = useState(false);
    const [isEditNotApplicableOpen, setIsEditNotApplicableOpen] = useState(false);
    const [isNotApplicableEdit, setIsNotApplicableEdit] = useState(false);
    const [likertScaleData, setLikertScaleData] = useState([]);
    const [chartData, setChartData] = useState({});

    const isChart = (criteria) => {
        return  criteria.criteria && (
                criteria.criteria.toUpperCase().includes("QPPM") ||
                criteria.criteria.toUpperCase().includes("QPIM") ||
                criteria.criteria.toUpperCase().includes("QIPM") ||
                criteria.criteria.toUpperCase().includes("DPPM") ||
                criteria.criteria.toUpperCase().includes("DBIC")) &&
            criteria.responseType.id === 3 &&
            !criteria.criteria.includes("?");
    }

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : 'panel1');
        newExpanded && fetchCriteriaComment()
        fetchLikertScaleData()
    };

    const handleAddEditComment = (criteriaId, type) => {
        if (type === "add") {
            setIsAddCommentOpen(true)
            setIsEditCommentOpen(false)
        } else {
            setIsAddCommentOpen(false)
            setIsEditCommentOpen(true)
        }
        setExpanded(`panel${criteriaId}`)
    }

    const handleOverrideScore = (criteriaId, type) => {
        if (type === "add") {
            setIsOverrideScoreOpen(true)
            setIsEditOverrideScoreOpen(false)
        } else if (type === "edit") {
            setIsOverrideScoreOpen(false)
            setIsEditOverrideScoreOpen(true)
        } else {
            setIsOverrideScoreOpen(false)
            setIsEditOverrideScoreOpen(false)
        }
        setExpanded(`panel${criteriaId}`)
    }

    const handleNotApplicable = (criteriaId, type) => {
        if (type === "add") {
            setIsNotApplicableOpen(true)
            setIsEditNotApplicableOpen(false)
        } else {
            setIsNotApplicableOpen(false)
            setIsEditNotApplicableOpen(true)
        }
        setExpanded(`panel${criteriaId}`)
    }

    const saveOverrideScore = (originalValue, overrideValue) => {
        setOriginalValue(originalValue);
        setOverrideValue(overrideValue)
    }

    const handleActions = (value, idValue, funcType) => {
        if (funcType === "visibility")
            updateVisibilityState("visibility", value)
        else if (funcType === "save")
            handleCommentsSave(value, idValue)
        else if (funcType === "edit-click")
            handleEditClick()
        else if (funcType === "update")
            updateComment(value, idValue, "updateComment")
        else if (funcType === "update-visibility")
            updateComment(value, idValue, "updateVisibility")
        else if (funcType === "delete")
            deleteComment(idValue)
        else if (funcType === "cancel") {
            setIsAddCommentOpen(false)
            setIsEditCommentOpen(false)
        }
    }

    const handleEditClick = () => {
        setIsEditCommentOpen(true)
    }

    const handleCommentsSave = (value, criteriaId) => {
        if (value && value !== "")
            saveComment(value, criteriaId)
        else {
            setIsEditCommentOpen(true)
            setIsAddCommentOpen(true)
        }
    }

    const fetchCriteriaComment = () => {
        let data = {
            supplierNumbers: suppliers.map(item => item.supplierNumber),
            criteriaId: criteria.id,
            period: ratingPeriod.period,
            fiscalYear: ratingPeriod.fiscalYear
        }

        authAxios.post(`/ratingCriteriaComment`, data)
            .then(res => {
                setCriteriaComments(res.data)
            }).catch((e) => {
            enqueueToast({
                variant: "error",
                title: "Error fetching comment",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        })
    }

    const fetchLikertScaleData = () => {
        authAxios.get(`/ratingLikertScaleDesc/${criteria.id}`)
            .then(res => {
                setLikertScaleData(res.data)
            }).catch((e) => {
            enqueueToast({
                variant: "error",
                title: "Error fetching likert scale description",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        })
    }

    const saveComment = (value, criteriaId) => {
        let data = {
            comment: value,
            supplierNumbers: suppliers.map(item => item.supplierNumber),
            criteriaId: criteriaId,
            period: ratingPeriod.period,
            fiscalYear: ratingPeriod.fiscalYear
        }

        authAxios.post(`/saveCriteriaComment`, data)
            .then(res => {
                setCriteriaComments(res.data)
                setIsEditCommentOpen(false)
                setIsAddCommentOpen(false)
                enqueueToast({
                    variant: "success",
                    title: "Criteria Comment Saved Successfully",
                    isCloseable: true
                });
            }).catch((e) => {
            enqueueToast({
                variant: "error",
                title: "Error saving comment",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        })
    };

    const updateComment = (value, commentId, type) => {
        const suppliersList = suppliers.map(item => item.supplierNumber)
        let data
        if (type === "updateComment")
            data = {
                comment: value,
                id: commentId,
                isCommentVisible: criteriaComments.filter(item => item.id === commentId)[0].isCommentVisible,
                visibilityUpdate: false,
                supplierNumbers: suppliersList
            }
        else
            data = {
                comment: criteriaComments.filter(item => item.id === commentId)[0].comment,
                id: commentId,
                isCommentVisible: value,
                visibilityUpdate: true,
                supplierNumbers: suppliersList
            }

        authAxios.put(`/ratingCriteriaComment`, data)
            .then(res => {
                setCriteriaComments(res.data)
                setIsEditCommentOpen(false)
                setIsAddCommentOpen(false)
                enqueueToast({
                    variant: "success",
                    title: "Criteria Comment Updated Successfully",
                    isCloseable: true
                });
            }).catch((e) => {
            enqueueToast({
                variant: "error",
                title: "Error updating comment",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        })
    };

    const deleteComment = (commentId) => {
        authAxios.delete(`/ratingCriteriaComment/${commentId}`)
            .then(res => {
                console.log(res.data)
                setCriteriaComments(res.data)
                setIsEditCommentOpen(false)
                setIsAddCommentOpen(false)
                enqueueToast({
                    variant: "success",
                    title: "Criteria Comment Deleted Successfully",
                    isCloseable: true
                });
            }).catch((e) => {
            enqueueToast({
                variant: "error",
                title: "Error deleting comment",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        })
    };

    const getChartData = async (supplierNumber, criteriaId) => {
        try {
            return await authAxios.get(`/rating/${supplierNumber}/${criteriaId}/chart`);
        } catch (e) {
            console.error('Error fetching chart data:', e);
            throw e;
        }
    };

    const handleOverrideActions = (data, type) => {
        if (type === "cancel") {
            setIsOverrideScoreOpen(false)
            setIsEditOverrideScoreOpen(false)
            setOverrideValue("")
        }
        if (type === "save") {
            setIsOverrideScoreOpen(false)
            setIsEditOverrideScoreOpen(false)
            setIsOverrideEdit(true)
            updateVisibilityState("override", data.data)
        }
        if (type === "update") {
            setIsOverrideScoreOpen(false)
            setIsEditOverrideScoreOpen(false)
            setIsOverrideEdit(true)
            updateVisibilityState("override", data.data)
        }
        if (type === "delete") {
            setIsOverrideScoreOpen(false)
            setIsEditOverrideScoreOpen(false)
            setIsOverrideEdit(false)
            updateVisibilityState("override-delete", data.data)
        }
    }

    const handleNotApplicableActions = (data, type) => {
        if (type === "cancel") {
            setIsNotApplicableOpen(false)
            setIsEditNotApplicableOpen(false)
        }
        if (type === "save") {
            setIsNotApplicableOpen(false)
            setIsEditNotApplicableOpen(false)
            setIsNotApplicableEdit(true)
            updateVisibilityState("notApplicable", data.data)
        }
        if (type === "update") {
            setIsNotApplicableOpen(false)
            setIsEditNotApplicableOpen(false)
            setIsNotApplicableEdit(true)
            updateVisibilityState("notApplicable", data.data)
        }
        if (type === "delete") {
            setIsNotApplicableOpen(false)
            setIsEditNotApplicableOpen(false)
            setIsNotApplicableEdit(false)
            updateVisibilityState("notApplicable-delete", data.data)
        }
    }

    useEffect(() => {
            if (criteria.responseType.id === 1 || criteria.responseType.id === 2 || criteria.responseType.id === 4)
                fetchCriteriaComment()
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [criteria]);

    useEffect(() => {
            if (criteria.overridePoints || criteria.overrideReason) {
                setIsOverrideEdit(true)
                setOriginalValue(criteria.weightage);
                setOverrideValue(criteria.overridePoints)
            } else {
                setIsOverrideEdit(false)
            }
        },// eslint-disable-next-line react-hooks/exhaustive-deps
        [criteria]);

    useEffect(() => {
             if (suppliers && suppliers.length > 0 && criteria.responseType.id === 3 &&
                 isChart(criteria)) {
                const promises = suppliers.map(supplier =>
                    getChartData(supplier.supplierNumber, criteria.id)
                        .then(response => {
                            if (response.data) {
                                return {supplierNumber: supplier.supplierNumber, data: response.data};
                            }
                            return undefined;
                        })
                        .catch(error => {
                            return undefined;
                        })
                );

                Promise.all(promises)
                    .then(results => {
                        const newChartData = {};
                        results.forEach(result => {
                            if (result) {
                                newChartData[result.supplierNumber] = result.data;
                            }
                        });
                        setChartData(newChartData);
                    });
            }
        },// eslint-disable-next-line react-hooks/exhaustive-deps
        [criteria]);

    useEffect(() => {
            if (criteria.notApplicableReason) {
                setIsNotApplicableEdit(true)
            } else {
                setIsNotApplicableEdit(false)
            }
        },// eslint-disable-next-line react-hooks/exhaustive-deps
        []);

    return (
        <CardContent
            style={{padding: 0, marginTop: 10}} key={criteria.id}>
            <div className={classes.root}>
                <Accordion
                    expanded={expanded === `panel${criteria.id}`}
                    onChange={(criteria.responseType.id === 3 && suppliers.length < 2 && !chartData?.[suppliers[0].supplierNumber]) ? () => {
                    } : handleChange(`panel${criteria.id}`)}
                >
                    {(criteria.responseType.id === 1 || criteria.responseType.id === 2 || criteria.responseType.id === 4) ?
                        <RatingCriteriaSummary
                            key={criteria}
                            criteria={criteria}
                            isActionsAllowed={isActionsAllowed}
                            criteriaComments={criteriaComments}
                            onCommentClick={handleAddEditComment}
                            onOverrideScoreClick={handleOverrideScore}
                            onOverrideScoreSave={saveOverrideScore}
                            userInfo={userInfo}
                            isSupplierMimic={isSupplierMimic}
                            isSupplierAdmin={isSupplierAdmin}
                            isOverrideEdit={isOverrideEdit}
                            isOverrideScoreOpen={isOverrideScoreOpen}
                            isEditOverrideScoreOpen={isEditOverrideScoreOpen}
                            onNotApplicableClick={handleNotApplicable}
                            isNotApplicableEdit={isNotApplicableEdit}
                            overrideValueInitial={overrideValue}
                        />
                        :
                        <RatingObjective
                            functionalAreaId={functionalAreaId}
                            criteria={criteria}
                            isActionsAllowed={isActionsAllowed}
                            isSupplierMimic={isSupplierMimic}
                            suppliers={suppliers}
                            onNotApplicableClick={handleNotApplicable}
                            isNotApplicableEdit={isNotApplicableEdit}
                            chartData={chartData}
                        />
                    }
                    {(criteria.responseType.id === 1 || criteria.responseType.id === 2 || criteria.responseType.id === 4) ?
                        <RatingCriteriaDetails
                            criteria={criteria}
                            suppliers={suppliers}
                            userInfo={userInfo}
                            isSupplierMimic={isSupplierMimic}
                            isActionsAllowed={isActionsAllowed}
                            isSupplierAdmin={isSupplierAdmin}
                            criteriaComments={criteriaComments}
                            isAddCommentOpen={isAddCommentOpen}
                            isEditCommentOpen={isEditCommentOpen}
                            isOverrideScoreOpen={isOverrideScoreOpen}
                            isEditOverrideScoreOpen={isEditOverrideScoreOpen}
                            onActions={handleActions}
                            originalValue={originalValue}
                            overrideValue={overrideValue}
                            onOverrideActions={handleOverrideActions}
                            isNotApplicableOpen={isNotApplicableOpen}
                            isEditNotApplicableOpen={isEditNotApplicableOpen}
                            onNotApplicableActions={handleNotApplicableActions}
                            likertScaleData={likertScaleData}
                        /> :
                        <RatingObjectiveDetails
                            functionalAreaId={functionalAreaId}
                            criteria={criteria}
                            suppliers={suppliers}
                            isNotApplicableOpen={isNotApplicableOpen}
                            isEditNotApplicableOpen={isEditNotApplicableOpen}
                            onNotApplicableActions={handleNotApplicableActions}
                            isParentOpen={expanded === `panel${criteria.id}`}
                            chartData={chartData}
                        />
                    }
                </Accordion>
            </div>
        </CardContent>
    )
}
